import { environment } from 'src/environments/environment';

export enum AIConfigPosition {
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  TOP_RIGHT = 'top-right',
  TOP_LEFT = 'top-left',
}
export interface AIConfig {
  type: 'chatWindow' | 'modal';
  iframeUrl: string;
  buttonSource: string;
  tooltip: string;
  position: AIConfigPosition;
  animationDuration: number;
  zIndex: number;
}

const applicationUrl = {
  local: 'http://localhost:3000',
  dev: 'https://dev2.expertpower.com',
  test: 'https://xpw2webtestv2.mangorock-e2ed0d8f.westeurope.azurecontainerapps.io',
  // test: 'https://test2.expertpower.com',
};

const getEnvironmentType = (
  redirectUri: string | undefined,
): 'local' | 'dev' | 'test' | 'prod' => {
  if (!redirectUri) return 'local';

  if (redirectUri.includes('localhost')) return 'local';
  if (redirectUri.includes('web.dev')) return 'dev';
  if (redirectUri.includes('test.expertpower')) return 'test';
  return 'prod';
};

const useEnvironment = getEnvironmentType(environment.redirectUri);

export const DEFAULT_CONFIG: AIConfig = {
  type: 'chatWindow',
  iframeUrl: `${applicationUrl[useEnvironment as keyof typeof applicationUrl] || applicationUrl.local}/en/ai-chat-window`,
  buttonSource: '',
  tooltip: 'AI Assistant',
  position: AIConfigPosition.BOTTOM_RIGHT,
  animationDuration: 300,
  zIndex: 999999,
};
